import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("试用版")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("付费版")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 确定 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_checkbox = _resolveComponent("a-checkbox")
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")
  const _component_a_radio = _resolveComponent("a-radio")
  const _component_a_radio_group = _resolveComponent("a-radio-group")
  const _component_a_date_picker = _resolveComponent("a-date-picker")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.store.state.business.addState,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_ctx.store.state.business.addState = $event)),
    width: "600px",
    title: _ctx.detail ? '编辑用户' : '新增用户',
    afterClose: _ctx.afterClose,
    onCancel: _ctx.afterClose,
    maskClosable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.afterClose
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        loading: _ctx.loading,
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.rules,
        "label-col": { span: 8 },
        "wrapper-col": { span: 16 },
        class: "form-content"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "商户名称",
            name: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                maxlength: 30,
                style: {"width":"300px"},
                value: _ctx.form.name,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
                placeholder: "商户名称（2-30个字符）"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "功能包",
            name: "pkgIds"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_checkbox_group, {
                value: _ctx.form.pkgIds,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.pkgIds = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.packageOptions, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_checkbox, {
                      key: index,
                      value: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "企业付费版本",
            name: "type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.form.type,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.type = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: 2 }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "端口数量",
            name: "numCount"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                maxlength: 30,
                style: {"width":"300px"},
                value: _ctx.form.numCount,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.numCount = $event)),
                placeholder: "请输入端口数量"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "收款金额",
            name: "money"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                maxlength: 30,
                style: {"width":"300px"},
                value: _ctx.form.money,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.money = $event)),
                placeholder: "请输入收款金额"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "开通了会话存档",
            name: "isOpenConversation"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.form.isOpenConversation,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.isOpenConversation = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "会话存档购买数",
            name: "convCount"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                maxlength: 30,
                style: {"width":"300px"},
                value: _ctx.form.convCount,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.convCount = $event)),
                placeholder: "请输入会话存档购买数"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "过期时间",
            name: "expireDate"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_date_picker, {
                style: {"width":"300px"},
                value: _ctx.form.expireDate,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.expireDate = $event)),
                placeholder: "过期时间",
                format: "yyyy-MM-DD"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "跟进人",
            name: "follower"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                maxlength: 30,
                style: {"width":"300px"},
                value: _ctx.form.follower,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.follower = $event)),
                placeholder: "请输入跟进人"
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["visible", "title", "afterClose", "onCancel"]))
}